var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.b({
    on: _vm.value,
    disabled: _vm.disabled
  }),style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{class:_vm.b('node')},[(_vm.loading)?_c('loader',{class:_vm.b('loading')}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74c20890","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/switch/index.vue
// module id = IJ61
// module chunks = 76